var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 0.666687C13.2614 0.666687 15.5 2.90526 15.5 5.66669C15.5 8.36535 13.362 10.5647 10.6874 10.6632L10.5 10.6667H6.33333V12.3334H9.66667C10.1269 12.3334 10.5 12.7065 10.5 13.1667C10.5 13.6269 10.1269 14 9.66667 14H6.33333V16.5C6.33333 16.9603 5.96024 17.3334 5.5 17.3334C5.03976 17.3334 4.66667 16.9603 4.66667 16.5V14H1.33333C0.873096 14 0.5 13.6269 0.5 13.1667C0.5 12.7065 0.873096 12.3334 1.33333 12.3334H4.66667V10.6667H1.33333C0.873096 10.6667 0.5 10.2936 0.5 9.83335C0.5 9.40599 0.8217 9.05377 1.23615 9.00563L1.33333 9.00002H4.66667V1.50002C4.66667 1.03978 5.03976 0.666687 5.5 0.666687H10.5ZM10.5 2.33335H6.33333V9.00002H10.5C12.3409 9.00002 13.8333 7.50764 13.8333 5.66669C13.8333 3.88152 12.43 2.42412 10.6664 2.33743L10.5 2.33335Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.764b241a.svg";
export { ForwardRef as ReactComponent };